import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ControlName } from '../../enums/control-name.enum';
import { Question } from '../../interfaces/meta/question';
import { QuestionContainer } from '../../interfaces/meta/question-container';

@Component({
    selector: 'smvd-shared-question-container',
    templateUrl: 'question-container.component.html',
})
export class QuestionContainerComponent {
    @Input() container: QuestionContainer;
    @Input() group: UntypedFormGroup;

    public showQuestion(question: Question): boolean {
        if (!question.dependency?.questionId) return true;
        return question.dependency.acceptedValues.includes(this.group.get(question.dependency.questionId)?.get(ControlName.Value)?.value);
    }
}
